















import { Component, Prop, Vue } from 'vue-property-decorator'
import { MenuItem as MenuItemProps } from '@/types/menu'

@Component
export default class MenuItem extends Vue {
  @Prop() readonly item!: MenuItemProps
  get hasChildren(): boolean {
    return this.item.children !== undefined && this.item.children.length > 0
  }
}
